module.exports = __webpack_public_path__ + "media/RakutenTvHero.1d924365.png";